import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardResolverService } from './dashboard-resolver.service';
import { AuthGuard } from '../../core/guards/auth.guard';


const routes: Routes = [{
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [
        AuthGuard
    ],
    data: {
        pageTitle: 'Dashboard'
    },
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DashboardRoutingModule {
}
